var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,15.999999C30,8.268014,23.731987,2,16,2S2,8.268014,2,15.999999 c0,6.9878683,5.1196933,12.7797575,11.812685,13.8298903v-9.7820778h-3.5556183V15.999999h3.5556183v-3.0850811 c0-3.5103359,2.0908451-5.4476151,5.2881451-5.4476151c1.5317116,0,3.1342983,0.2736588,3.1342983,0.2736588v3.4453673h-1.7659969 c-1.7404003,0-2.2818165,1.0808611-2.2818165,2.1873159v2.6263542h3.8824368l-0.6201668,4.0478125h-3.26227v9.7820778 C24.8803062,28.7797565,30,22.9878674,30,15.999999z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSmall);
export default __webpack_public_path__ + "static/media/facebook--small.ea6f8e932ae1c72d899a3dcd85069ac8.svg";
export { ForwardRef as ReactComponent };